import { render, staticRenderFns } from "./drugTarget.vue?vue&type=template&id=2ab03bec&scoped=true&"
import script from "./drugTarget.vue?vue&type=script&lang=js&"
export * from "./drugTarget.vue?vue&type=script&lang=js&"
import style0 from "./drugTarget.vue?vue&type=style&index=0&id=2ab03bec&scoped=true&lang=css&"
import style1 from "./drugTarget.vue?vue&type=style&index=1&id=2ab03bec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab03bec",
  null
  
)

export default component.exports